import React, { Fragment } from 'react'
import { Logo } from '../Logo'
import { SearchContainer } from '../Search'
import GuestUserProfile from './GuestUserProfile'
import GuestCart from './GuestCart'
import Helmet from 'react-helmet'
import HeaderWrapper from '../HeaderWrapper'
import { MainMenuPublicContainer } from 'App/MainMenu'
import yn from 'yn'

const GuestHeader = () => (
  <Fragment>
    <HeaderWrapper>
      {yn(process.env.REACT_APP_NO_INDEX) && (
        <Helmet>
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
      )}
      <Logo />
      <SearchContainer />
      <GuestUserProfile />
      {window.innerWidth > 767 ? <GuestCart /> : ''}
    </HeaderWrapper>
    <MainMenuPublicContainer />
  </Fragment>
)

export default GuestHeader



// WEBPACK FOOTER //
// ./src/App/Header/GuestHeader/GuestHeader.js